import Consultation from "js/views/components/Consultation";
import DDButton from "js/views/components/DDButton";
import React, { useEffect, useState } from "react";
import { animate } from "motion";

import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import { getDiagnoses } from "js/redux/actions/diagnoses";
import LoaderDiv from "../components/LoaderDiv";
import VerticalLine from "../components/VerticalLine";

import { ToastContainer, toast } from "react-toastify";
import ReactPaginate from "react-paginate";
import Dropdown from "../components/Dropdown";
import camera from "assets/icons/camera-bold.svg";
import video from "assets/icons/video-bold.svg";
import home from "assets/icons/home.svg";
import { getExchangeCode } from "js/redux/actions/user";

function Consultations({
  consultations,
  getDiagnoses,
  region,
  t,
  user_uuid,
  token,
  userName,
  getExchangeCode,
  exchangeCode,
  userData,
}) {
  const [prevConsultations, setPrevConsultations] = useState([]);
  const [liveConsultations, setLiveConsultations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [redirectingTo, setRedirectingTo] = useState(null);

  const notify = () => toast.error("Something unexpected has occurred!");

  const getSetDiagnoses = async (pageNo) => {
    setLoading(true);
    setError(false);
    setPageNo(pageNo);
    await getDiagnoses(
      pageNo,
      () => {
        setLoading(false);
      },
      () => {
        setLoading(false);
        notify();
      },
    );
  };

  useEffect(() => {
    if (consultations && consultations.total) {
      setTotalPage(Math.ceil(consultations.total / 10));
    }
  }, [consultations]);

  const redirect = () => {
    window.location.replace(process.env.REACT_APP_CHECK_URL);
  };

  useEffect(() => {
    const pg = localStorage.getItem("pageNo");
    if (pg) {
      setPageNo(parseInt(pg));
      getSetDiagnoses(parseInt(pg));
      localStorage.removeItem("pageNo");
    } else {
      getSetDiagnoses(1);
    }
  }, []);

  useEffect(() => {
    if (consultations && consultations.data && consultations.data.length > 0) {
      const sortConsultations = (consultations) => {
        let prev = [];
        let live = [];
        consultations.forEach((consultation) => {
          live.push(consultation);
        });
        //Sort prev & live consultations before storing in state
        prev.sort((a, b) => (a.updated_at < b.updated_at ? 1 : -1));
        live.sort((a, b) => (a.created_at < b.created_at ? 1 : -1));
        setPrevConsultations(prev);
        setLiveConsultations(live);
      };

      sortConsultations(consultations.data);
      animate(
        ".consultations .consultation-header, h2 ",
        { opacity: [0, 1] },
        { duration: 0.8, easing: "ease-out" },
      );
    }
  }, [consultations]);

  const buildConsultations = (list) => {
    return list.map((item, index) => (
      <li className="consultation-li" key={index}>
        <Consultation {...item} pageNo={pageNo} />
      </li>
    ));
  };

  const getBaseUrl = () => {
    const env = process.env.REACT_APP_ENV;
    if (env === "development") {
      return "http://localhost:8081";
    } else if (env !== "production") {
      return "https://staging.booking.skin.drdropin.no";
    } else {
      return "https://booking.skin.drdropin.no";
    }
  };

  const handleRedirection = async (flow) => {
    setRedirectingTo(flow);
    try {
      const result = await getExchangeCode({
        token: token,
      });
      if (result) {
        window.open(
          `${getBaseUrl()}/book?flow=${flow}&name=${
            userData.firstname ?? "User"
          }&code=${result}&uuid=${user_uuid}`,
          "_blank",
        );
      } else {
        window.open(`${getBaseUrl()}/book?flow=${flow}`, "_blank");
      }
    } catch (err) {
      console.log("error in getting exchange code", err);
    }
    setRedirectingTo(null);
  };

  const dropdownLinks = [
    <button
      className="link"
      key="picture-consultation-link"
      onClick={async () => {
        handleRedirection("picture");
      }}
    >
      <img alt="camera" src={camera} className="link-img" />
      {t("dashboard.photo_consultation")}
      {redirectingTo && redirectingTo === "picture" && (
        <div style={{ height: "20px", width: "24px" }}>
          <LoaderDiv />
        </div>
      )}
    </button>,
    <button
      className="link"
      key="video-consultation-link"
      onClick={async () => {
        handleRedirection("video");
      }}
    >
      <img alt="video" src={video} className="link-img" />
      {t("dashboard.video_consultation")}
      {redirectingTo && redirectingTo === "video" && (
        <div style={{ height: "20px", width: "24px" }}>
          <LoaderDiv />
        </div>
      )}
    </button>,
    <button
      className="link"
      key="clinic-consultation-link"
      onClick={() => {
        if (process.env.REACT_APP_ENV !== "production") {
          window.open(
            `https://staging.booking.drdropin.no/?vertical=dermatologist`,
            "_blank",
          );
        } else {
          window.open(
            `https://booking.drdropin.no/?vertical=dermatologist`,
            "_blank",
          );
        }
      }}
    >
      <img alt="clinic" src={home} className="link-img" />
      {t("dashboard.clinic_consultation")}
    </button>,
  ];

  return error ? (
    <div className="consultations">
      <div className="error-div">
        <span> {t("errors.something_unexpected")}</span>
        <button onClick={getSetDiagnoses}>{t("errors.retry")}</button>
      </div>
      <ToastContainer position="bottom-center" />
    </div>
  ) : (
    <div className="consultations">
      <div className="consultation-header">
        <h1>{t("dashboard.my_consultations")}</h1>
        {/* <DDButton onClick={redirect} className="add-button">
          {t("dashboard.action.new")}
        </DDButton> */}
        <Dropdown
          addTimer={true}
          options={dropdownLinks}
          userName={t("dashboard.book_appointment")}
        />
      </div>
      <VerticalLine />
      <section className="consultation-block">
        {/* <h2>{t("dashboard.consultations.live")}</h2> */}

        {loading ? (
          <div className="loaderContainer">
            <LoaderDiv />
          </div>
        ) : liveConsultations.length < 1 ? (
          <ul className="consultations-list">
            <span className="text-muted text-div-container">
              {t("dashboard.consultations.no_live")}
            </span>
          </ul>
        ) : (
          <ul className="consultations-list">
            {buildConsultations(liveConsultations)}
          </ul>
        )}
      </section>

      <ReactPaginate
        breakLabel="..."
        nextLabel=">"
        onPageChange={(pageNo) => getSetDiagnoses(pageNo.selected + 1)}
        forcePage={pageNo - 1}
        pageRangeDisplayed={5}
        pageCount={totalPage}
        previousLabel="<"
        className="pagination"
        renderOnZeroPageCount={null}
      />
    </div>
  );
}

function mapStateToProps(state) {
  return {
    bankIdOperationId: state.auth.bankIdOperationId,
    region: state.auth.region,
    locale: state.auth.locale,
    consultations: state.diagnoses.consultations,
    user_uuid: state.auth.user_uuid,
    token: state.auth.token,
    userName: state.auth.userName,
    exchangeCode: state.auth.exchangeCode,
    userData: state.auth.userData,
  };
}

export default connect(mapStateToProps, {
  getDiagnoses,
  getExchangeCode,
})(withTranslation()(Consultations));
